/**
 * Bitrix Messenger
 * Device constants
 *
 * @package bitrix
 * @subpackage im
 * @copyright 2001-2020 Bitrix
 */

export const DeviceType = Object.freeze({
	mobile: 'mobile',
	desktop: 'desktop',
});

export const DeviceOrientation = Object.freeze({
	horizontal: 'horizontal',
	portrait: 'portrait',
});